import React from 'react';

/**
 * ButtonProps defines the props for the Button component.
 */
export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'ghost' | 'default';
  size?: 'icon' | 'default';
}

/**
 * Utility to join class names, filtering out falsy values.
 */
function classNames(...classes: (string | false | null | undefined)[]) {
  return classes.filter(Boolean).join(' ');
}

/**
 * Button component styled for Tailwind and shadcn usage.
 * Supports 'ghost' variant and 'icon' size.
 */
export const Button: React.FC<ButtonProps> = ({
  variant = 'default',
  size = 'default',
  className = '',
  children,
  ...props
}) => {
  const base = 'inline-flex items-center justify-center focus:outline-none transition-colors';
  const variants: Record<string, string> = {
    default: 'bg-primary text-white hover:bg-primary/90',
    ghost: 'bg-transparent hover:bg-accent',
  };
  const sizes: Record<string, string> = {
    default: 'px-4 py-2 rounded-md text-sm',
    icon: 'p-2 rounded-full',
  };
  return (
    <button
      type="button"
      className={classNames(base, variants[variant], sizes[size], className)}
      {...props}
    >
      {children}
    </button>
  );
};
